import { kebabCase } from 'lodash-es';

export const DOCUMENT_RENDERER_CONTENT_TEST_ID = 'document-renderer-content';
export const DOCUMENT_RENDERER_TIFF_IMAGE_TEST_ID = 'document-renderer-tiff-image';
export const DOCUMENT_RENDERER_WEB_IMAGE_TEST_ID = 'document-renderer-web-image';
export const DOCUMENT_VIEWER_CONTROL_MENU_BUTTON_TEST_ID = 'document-viewer-control-menu-button';
export const DOCUMENT_VIEWER_DETAIL_FIELD_TEST_ID = 'document-viewer-detail-field';
export const DOCUMENT_VIEWER_HEADER_FIELD_TEST_ID = 'document-viewer-header-field';
export const DOCUMENT_VIEWER_DETAIL_SUBSECTION_TEST_ID = 'document-viewer-detail-subsection';
export const VERTICAL_SUB_NAVIGATION_DOCK_TEST_ID = 'vertical-sub-navigation-dock';
export const VERTICAL_SUB_NAVIGATION_EXPAND_COLLAPSE_BUTTON_TEST_ID =
  'vertical-sub-navigation-dock-expand-collapse-button';
export const SUB_NAVIGATION_BAR_TEST_ID = 'sub-navigation-bar';
export const SUB_NAVIGATION_DRAWER_BUTTON_TEST_ID = 'sub-navigation-drawer-button';
export const NAVIGATION_STACK_TEST_ID = 'navigation-stack';
export const DOCUMENT_VIEWER_TABLE_TEST_ID = 'document-viewer-table';
export const DOCUMENT_VIEWER_SELECTION_CONTEXT_BAR_TEST_ID =
  'document-viewer-selection-context-bar' as const;
export const DOCUMENT_VIEWER_SECTION_CLASSNAME = 'document-viewer-section' as const;
export const DOCUMENT_VIEWER_SECTION_TEST_ID = 'document-viewer-section';
export const DOCUMENT_VIEWER_SECTION_HEADING_TEST_ID = 'document-viewer-section-heading';
export const DOCUMENT_VIEWER_BR_TEST_ID = 'document-viewer-br';
export const DOCUMENT_VIEWER_TEXT_TEST_ID = 'document-viewer-text';
export const DOCUMENT_VIEWER_CDATA_TEST_ID = 'document-viewer-cdata';
export const DOCUMENT_VIEWER_SPAN_TEST_ID = 'document-viewer-span';
export const DOCUMENT_VIEWER_LIST_TEST_ID = 'document-viewer-list';
export const DOCUMENT_VIEWER_LIST_ITEM_TEST_ID = 'document-viewer-list-item';
export const DOCUMENT_VIEWER_LINK_TEST_ID = 'document-viewer-link';
export const DOCUMENT_VIEWER_HEADING_TEST_ID = 'document-viewer-heading';
export const MAIN_NAVIGATION_BAR_TEST_ID = 'main-navigation-bar';
export const MAIN_NAVIGATION_BAR_DRAWER_BUTTON_TEST_ID = 'main-navigation-bar-drawer-button';
export const MAIN_NAVIGATION_BAR_DRAWER_SCRIM_TEST_ID = 'main-navigation-bar-drawer-scrim';
export const PROFILE_MENU_TEST_ID = 'profile-menu';
export const PROFILE_MENU_IMPERSONATION_LABEL_TEST_ID = 'profile-menu-impersonation-label';
export const PROFILE_MENU_IMPERSONATION_STOP_TEST_ID = 'profile-menu-impersonation-stop';
export const PROFILE_MENU_VIEW_AS_TEST_ID = 'profile-menu-view-as';
export const PROFILE_MENU_IMPERSONATE_TEST_ID = 'profile-menu-impersonate';
export const IMPERSONATION_BUILDER_PICKER_LIST_TEST_ID = 'impersonation-builder-picker-list';
export const IMPERSONATION_BUILDER_PICKER_SEARCH_TEST_ID = 'impersonation-builder-picker-search';
export const IMPERSONATION_ROLE_PICKER_TEST_ID = 'impersonation-role-picker';
export const IMPERSONATION_ROLE_PICKER_CUSTOM_ROLES_TEST_ID =
  'impersonation-role-picker-custom-roles';
export const IMPERSONATE_MODAL_CONFIRM_TEST_ID = 'impersonate-modal-confirm';
export const IMPERSONATE_MODAL_CONTENT_TEST_ID = 'impersonate-modal-content';
export const DOCUMENT_VIEWER_TABS_TEST_ID = 'document-viewer-tabs';
export const DOCUMENT_VIEWER_TAB_TEST_ID = 'document-viewer-tab';
export const DOCUMENT_VIEWER_TAB_MENU_BUTTON_TEST_ID = 'document-viewer-tab-menu-button';
export const DOCUMENT_VIEWER_TAB_MENU_TEST_ID = 'document-viewer-tab-menu';
export const DOCUMENT_VIEWER_TAB_MENU_ITEM_TEST_ID = 'document-viewer-tab-menu-item';
export const TABLE_OF_CONTENTS_SCROLL_SPY_VERTICAL_TEST_ID =
  'table-of-contents-scroll-spy-vertical';
export const TABLE_OF_CONTENTS_SCROLL_SPY_VERTICAL_ITEM_TEST_ID =
  'table-of-contents-scroll-spy-vertical-item';
export const TABLE_OF_CONTENTS_SCROLL_SPY_HORIZONTAL_TEST_ID =
  'table-of-contents-scroll-spy-horizontal';
export const TABLE_OF_CONTENTS_SCROLL_SPY_HORIZONTAL_ITEM_TEST_ID =
  'table-of-contents-scroll-spy-horizontal-item';
export const TABLE_OF_CONTENTS_SCROLL_SPY_HORIZONTAL_MENU_BUTTON_TEST_ID =
  'table-of-contents-scroll-spy-horizontal-menu-button';
export const TABLE_OF_CONTENTS_SCROLL_SPY_HORIZONTAL_MENU_TEST_ID =
  'table-of-contents-scroll-spy-horizontal-menu';
export const TABLE_OF_CONTENTS_SCROLL_SPY_HORIZONTAL_MENU_ITEM_TEST_ID =
  'table-of-contents-scroll-spy-horizontal-menu-item';
export const DOCUMENT_VIEWER_CONTROL_BUTTON_CLOSE_TEST_ID = 'document-viewer-control-button-close';
export const DOCUMENT_VIEWER_CONTROL_BUTTON_BACK_TEST_ID = 'document-viewer-control-button-back';
export const DOCUMENT_VIEWER_CONTROL_BUTTON_PRINT_TEST_ID = 'document-viewer-control-button-print';
export const DOCUMENT_VIEWER_CONTROL_BUTTON_DOWNLOAD_RAW_TEST_ID =
  'document-viewer-control-button-download-raw';
export const DOCUMENT_VIEWER_CONTROL_BUTTON_DOWNLOAD_PDF_TEST_ID =
  'document-viewer-control-button-download-pdf';
export const DOCUMENT_VIEWER_CONTROL_BUTTON_OPEN_IN_NEW_TAB_TEST_ID =
  'document-viewer-control-button-open-in-new-tab';
export const DOCUMENT_VIEWER_CONTROL_MENU_DOWNLOAD_TEST_ID =
  'document-viewer-control-menu-download';
export const MAIN_CONTENT_SHEET_TEST_ID = 'main-content-sheet';
export const DETAIL_CONTENT_SHEET_TEST_ID = 'detail-content-sheet';
export const MAIN_CONTENT_ID = 'main-content';
export const MAIN_CONTENT_SHEET_ID = 'main-content-sheet';
export const DETAIL_CONTENT_SHEET_ID = 'detail-content-sheet';
export const CONTENT_CARD_TEST_ID = 'content-card';
export const CONTENT_CARD_TITLE_TEST_ID = 'content-card-title';
export const CONTENT_CARD_HEADER_TEST_ID = 'content-card-header';
export const CONTENT_CARD_BODY_TEST_ID = 'content-card-body';
export const DEFINITION_LIST_TEST_ID = 'definition-list';
export const DEFINITION_LIST_ITEM_TEST_ID = 'definition-list-item';
export const DEFINITION_LIST_ITEM_LABEL_TEST_ID = 'definition-list-item-label';
export const DEFINITION_LIST_ITEM_VALUE_TEST_ID = 'definition-list-item-value';
export const MODAL_WRAPPER_TEST_ID = 'modal-wrapper';
export const MODAL_CONTENT_CONTAINER_TEST_ID = 'modal-content-container';
export const HOTLOAD_GATE_TEST_ID = 'hotload-gate';

export const mainNavigationBarLinkTestId = (label: string) =>
  `main-navigation-bar-link-${kebabCase(label)}`;
export const mainNavigationBarMenuLinkTestId = (menuLabel: string, linkLabel: string) =>
  `main-navigation-bar-menu-${menuLabel}-${linkLabel}`;
export const mainNavigationDrawerMainNavigationLinkTestId = (label: string) =>
  `main-navigation-drawer-main-navigation-link-${kebabCase(label)}`;
export const mainNavigationDrawerSubNavigationLinkTestId = (label: string) =>
  `main-navigation-drawer-sub-navigation-link-${kebabCase(label)}`;
export const mainNavigationDrawerCollapsibleMenuTestId = (title: string) =>
  `main-navigation-drawer-collapsible-menu-${kebabCase(title)}`;

export const subNavigationBarLinkTestId = (label: string) =>
  `vertical-sub-nav-dock-link-${kebabCase(label)}`;
